const timeMixins = {
  data () {
    return {
      optionTimeData: {}, // 初始化时间
      TimePeriod: {}, // 提交选择的生效时间对象，
      iftttReverseDelayChecked: false,
      seqCycleNum: 1,//循环自动化生效次数
    }
  },

  methods: {
  }
};


export default timeMixins;